import React from 'react';
import { Box, Typography } from '@mui/material';
import Promos from '../Promos';
import BackButton from '../BackButton';

const PromosScreen = () => {
  return (
    <Box>
      <BackButton />
      <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 600 }}>
        Promotions
      </Typography>
      <Promos />
    </Box>
  );
};

export default PromosScreen;
